/**
 * z-index定数
 * CSS変数（z-index.css）と同期した値
 * インラインスタイルで使用する場合はこちらを使用
 */

export const Z_INDEX = {
  // ベース要素 (1-9)
  base: 1,
  raised: 2,
  elevated: 3,

  // パネル内要素 (10-49)
  panel: 10,
  panelOverlay: 20,

  // スティッキー/固定要素 (50-99)
  sticky: 50,
  header: 80,

  // ドロップダウン/ナビゲーション (100-999)
  dropdown: 100,
  nav: 150,
  navDropdown: 200,
  loadingOverlay: 300,

  // モーダル (1000-1099)
  modalBackdrop: 1000,
  modal: 1010,
  modalContent: 1020,

  // ネストモーダル (1100-1199)
  modalNestedBackdrop: 1100,
  modalNested: 1110,
  modalNestedContent: 1120,

  // ポップオーバー/ツールチップ (1200-1299)
  popover: 1200,
  tooltip: 1250,

  // トースト/通知 (1300+)
  toast: 1300,

  // ライトボックス
  lightbox: 1400,

  // 緊急用
  max: 9999,
} as const;

export type ZIndexKey = keyof typeof Z_INDEX;
